export const processedSelector = [
  { value: 'true', label: 'True' },
  { value: 'false', label: 'False' },
];
